<template>
    <div class="batch-dialog">
        <el-dialog :title="$t('Sell.Dialog.chang_time')" :visible.sync="visible">
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-width="140px"
                label-suffix=" : "
                label-position="right">
                <el-form-item :label="$t('Choose.choose')" >
                    <el-radio
                        style="width: 100%;"
                        v-model="form.option"
                        :label="1"
                    >{{ $t('Sell.Dialog.choosed_contract') }}{{ contracts.length }}{{ $t('Choose.one') }}
                    </el-radio>
                    <el-radio
                        style="margin-left: 0;"
                        v-model="form.option"
                        :label="2">{{ $t('Sell.Dialog.filter_total') }}{{ total }}{{ $t('Charge.count') }}
                    </el-radio>
                </el-form-item>
                <el-form-item :label="$t('Sell.Dialog.start_time')" prop="startAt">
                    <el-date-picker
                        style="width: 190px"
                        v-model="form.startAt"
                        value-format="yyyy-MM-dd"
                        type="date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')" prop="remark">
                    <el-input
                        style="width: 370px;"
                        :placeholder="$t('Fill.fill_remark')"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 10 }"
                        v-model="form.remark"/>
                </el-form-item>
                <el-form-item>
                    <span class="batch-dialog-size">
                        {{ $t('Sell.Dialog.tip') }}
                    </span>
                </el-form-item>
            </el-form>
            <div style="text-align:center">
                <el-button
                    type="primary"
                    slot="footer"
                    @click="submit"
                >{{ $t('Message.confirm') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
    },
    // member personal locker cardsCon-储值卡合同管理
    props: ['activeName', 'filter', 'total', 'tableData', 'date'],
    data() {
        return {
            visible: false,
            contractNum: null,
            clientInfo: {},
            form: {
                option: 1,
                startAt: null,
                remark: null,
                contractNums: [],
                filter: {},
            },
            rules: {
                startAt: { required: true, message: this.$t('Choose.start_time') },
            },
            type: null,
            contracts: [],
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                option: 1,
                startAt: null,
                remark: null,
                contractNums: [],
                filter: {},
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        handleUrl() {
            if (this.activeName === 'member') this.type = 'mshp';
            else if (this.activeName === 'personal') this.type = 'coach';
            else if (this.activeName === 'locker') this.type = 'locker';
            else if (this.activeName === 'cardsCon') this.type = 'cz-card';
        },
        open(contracts) {
            this.contracts = contracts;
            this.visible = true;
            this.handleUrl();
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (this.form.option === 1 && !this.contracts.length) {
                    return $ele.$alert(this.$t('Alert.choose_one'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                    });
                };
                if (this.form.option === 1) this.form.contractNums = this.contracts.map(el => el.contractNum);
                else this.form.contractNums = this.tableData.map(el => el.contractNum);

                this.form.filter = this.filter;
                if (this.date.length) {
                    this.form.filter.createdAtStart = this.date[0];
                    this.form.filter.createdAtEnd = this.date[1];
                }
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            API.post(`contract/${this.type}/start-at`, form)
            .then(() => {
                $ele.$message.success(this.$t('Message.refersh'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.batch-dialog {
    .el-dialog {
        width: 710px;
    }
    .el-range-separator {
        width: auto;
    }
}
.batch-dialog-size {
    font-size: 12px;
}
</style>
